import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    width: '120px',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
    position: 'relative',
    zIndex: 20,
    background: 'white',
    left: '28px',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  containerDocked: {
    width: '120px',
    minHeight: '200px',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
    position: 'absolute',
    zIndex: 20,
    background: 'white',
    left: '28px',
    display: 'flex',
    flexDirection: 'column',
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '5px',
    '&:hover': {
      background: '#e3e5fa',
    },
  },
  headerContainerBlue: {
    background: '#3C419A',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '5px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },
  headerAnnotation: {
    display: 'inline-flex',
    padding: '10px',
    borderBottom: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  closeIcon: {
    color: 'white',
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  listItem: {
    width: '40%',
    justifyContent: 'center',
  },
  listItemDisabled: {
    width: '50%',
    justifyContent: 'center',
    filter: 'grayscale(1)',
    pointerEvents: 'none',
  },
  dynamicIcon: {
    background:
      'linear-gradient(#BC0000, #BC0000) top left, linear-gradient(#BC0000, #BC0000) top left, linear-gradient(#BC0000, #BC0000) top right, linear-gradient(#BC0000, #BC0000) top right, linear-gradient(#BC0000, #BC0000) bottom left, linear-gradient(#BC0000, #BC0000) bottom left, linear-gradient(#BC0000, #BC0000) bottom right, linear-gradient(#BC0000, #BC0000) bottom right',
    backgroundSize: '2px 7px, 7px 2px',
    backgroundRepeat: 'no-repeat',
    padding: '1px',
  },
 activeColorBorder: {
 border: '2px solid white',
 '& .MuiBadge-badge' :{
  border: '1px solid white',
 }
  },
  nonActive: {
    padding: '5px',
    borderRadius: '5px',
    '& .makeStyles-icon': {
      border: '1px solid white',
    },
  },
  activeColor: {
    padding: '5px',
    borderRadius: '5px',
    background: '#ffd0d0',
    '& .makeStyles-icon': {
      border: '1px solid white',
    },
  },
  cursor: {
    cursor: 'all-scroll',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  badge: {
    "& .MuiBadge-badge": {
      right: '8px'
    }
  }
}));
